import { useState, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Footer from './components/Footer';
import Header from './components/Header';
import LoadingAnimation from './components/LoadingAnimation';
import './style.css';

// Lazy load components for better performance
const Home = lazy(() => import('./components/Home'));
const Contact = lazy(() => import('./components/Contact'));
const Portfolio = lazy(() => import('./components/Portfolio'));

// Define the App component
const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LoadingAnimation />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Router>
        {/* Render the Header component */}
        <Header className="h-120" />
        {/* Render the main content area */}
        <main className="flex-1 md:pt-12 lg:pt-24">
          {/* Render the Routes component with Suspense for lazy loading */}
          <Suspense fallback={<LoadingAnimation />}>
            <Routes>
              {/* Define the root route that redirects to the home route */}
              <Route path="/" element={<Navigate to="/home" replace />} />
              {/* Define the home route */}
              <Route path="/home" element={<Home />} />
              {/* Define the portfolio route */}
              <Route path="/portfolio" element={<Portfolio />} />
              {/* Define the contact route */}
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Suspense>
        </main>
        {/* Render the Footer component - now it will stick to bottom */}
        <Footer />
      </Router>
    </div>
  );
};

export default App;